
import $ from "jquery"
import { Factory as SortSelectPickerFactory } from "components/js_selectpicker/sort_selectpicker"
import MapMode from "app/map/mode/manager"


const DEFAULT_SELECTOR = {
  scope:                  ".page-cities-search__map-sidebar",
  sort_button:            ".page-cities-search__map-sidebar--heading--sort-button",
}


const initJSMapSidebarToggle = (el: string | Element | JQuery) => {
  const $map_container = $(".map-container")

  MapMode.on("card_mode", () => {
    $map_container.removeClass("with-state--sidebar-disabled")
  })
  MapMode.on("map_mode", () => {
    if (!$map_container.hasClass("with-state--sidebar-disabled")){
      $map_container.addClass("with-state--sidebar-disabled")
    }
  })
  $(el).on("click", () => {
    $map_container.toggleClass("with-state--sidebar-disabled")
  })
}

const initSortButton = () => {
  const $scope = $(DEFAULT_SELECTOR.scope)
  const $main = $scope.find(DEFAULT_SELECTOR.sort_button)
  return SortSelectPickerFactory.create({scope: $scope, main: $main})
}

export default {
  initJSMapSidebarToggle,
  initSortButton,
}
